// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_is-0";